export function getPlural(num: number, str: string): string {
  return `${str}${Math.abs(num) === 1 ? '' : 's'}`;
}
